export default __webpack_public_path__ + "static/media/toggleon.2d8b6570.svg";